import { render, staticRenderFns } from "./City.vue?vue&type=template&id=3855a55b"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports